import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useCallback, useMemo, useState } from "react";
import { ChevronRight, IconButton, InputUI, Typography } from "@parkschannel/ui";
import classNames from "classnames";
import { useTripPlanerContext } from "../TripPlannerContext";
export const ProductSection = (param)=>{
    let { data , children , defaultActive  } = param;
    const { isProductChecked , onToggleProduct  } = useTripPlanerContext();
    const isChecked = useMemo(()=>isProductChecked(data.id), [
        isProductChecked
    ]);
    const [isActive, setIsActive] = useState(defaultActive || !isChecked);
    const handleToggleActive = useCallback(()=>setIsActive((prev)=>!prev), [
        isActive
    ]);
    const handleToggleProduct = useCallback(()=>{
        if (!isChecked) {
            setIsActive(false);
        }
        onToggleProduct(data.id);
    }, [
        onToggleProduct,
        data.id
    ]);
    return /*#__PURE__*/ _jsxs("section", {
        onClick: handleToggleActive,
        className: classNames("rounded p-3 cursor-pointer transition", {
            "bg-white": !isChecked,
            "bg-neutral-100": isChecked
        }),
        children: [
            /*#__PURE__*/ _jsxs("div", {
                className: classNames("w-full flex justify-between items-center", {
                    "mb-3": isActive
                }),
                children: [
                    /*#__PURE__*/ _jsx("div", {
                        onClick: (e)=>e.stopPropagation(),
                        children: /*#__PURE__*/ _jsx(InputUI.CheckBox, {
                            checked: isChecked,
                            onChange: handleToggleProduct,
                            className: "!h-5 !w-5",
                            name: data.title,
                            id: data.title,
                            text: /*#__PURE__*/ _jsx(Typography, {
                                component: "h4",
                                variant: "h6",
                                className: "text-neutral-800 select-none",
                                children: data.title
                            })
                        })
                    }),
                    /*#__PURE__*/ _jsx(IconButton, {
                        icon: /*#__PURE__*/ _jsx(ChevronRight, {
                            className: classNames("w-5 h-5", {
                                "-rotate-90": isActive,
                                "rotate-90": !isActive
                            })
                        }),
                        size: "sm",
                        variant: "text"
                    })
                ]
            }),
            /*#__PURE__*/ _jsx("div", {
                onClick: (e)=>e.stopPropagation(),
                children: isActive && children
            })
        ]
    });
};
